var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightCart = function SvgLightCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.6 6v1.2h4.8V6c0-1.324-1.077-2.4-2.4-2.4A2.4 2.4 0 0 0 9.6 6M8.4 8.4H4.8v12h14.4v-12h-3.6V12h-1.2V8.4H9.6V12H8.4V8.4m0-1.2V6a3.6 3.6 0 0 1 7.2 0v1.2h4.8v14.4H3.6V7.2h4.8"
  })));
};
export default SvgLightCart;